var map = {
	"./404.svg": 73771,
	"./bug.svg": 1748,
	"./chart.svg": 93931,
	"./clipboard.svg": 8446,
	"./component.svg": 83766,
	"./dashboard.svg": 27507,
	"./documentation.svg": 74520,
	"./drag.svg": 16883,
	"./edit.svg": 98074,
	"./education.svg": 98792,
	"./email.svg": 36357,
	"./example.svg": 15131,
	"./excel.svg": 1954,
	"./exit-fullscreen.svg": 1474,
	"./eye-open.svg": 82779,
	"./eye.svg": 44891,
	"./form.svg": 72895,
	"./fullscreen.svg": 26130,
	"./guide.svg": 38736,
	"./icon.svg": 517,
	"./international.svg": 11799,
	"./language.svg": 73866,
	"./link.svg": 94718,
	"./list.svg": 77939,
	"./lock.svg": 1120,
	"./message.svg": 61815,
	"./money.svg": 99572,
	"./nested.svg": 3436,
	"./password.svg": 6516,
	"./pdf.svg": 2481,
	"./people.svg": 67042,
	"./peoples.svg": 2953,
	"./qq.svg": 62805,
	"./search.svg": 47337,
	"./shopping.svg": 97810,
	"./size.svg": 48665,
	"./skill.svg": 27086,
	"./star.svg": 41136,
	"./tab.svg": 1977,
	"./table.svg": 25035,
	"./theme.svg": 99685,
	"./tree-table.svg": 94983,
	"./tree.svg": 5304,
	"./user.svg": 66291,
	"./wechat.svg": 67457,
	"./zip.svg": 46774
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;